import * as BBApi from '..';
import moment, { Moment } from "moment";

const rootUrl = BBApi.host + '/oplevalt/experiences/';

export const search = async (searchText: string = '') => {
	const url = new URL(rootUrl);
	url.searchParams.append('search', searchText);

	const response = await BBApi.get(url.href);
	const searchResult = await response.json();
	return searchResult;
};

export const create = async (experience: any) => {
	const response = await BBApi.post(rootUrl, experience);
	const experienceId = await response.text();
	return experienceId;
};

export const get = async (experienceId: number) => {
	const response = await BBApi.get(rootUrl + `/${experienceId}`);
	const experience = await response.json();

	experience.variations.forEach((variation: any) => {
		if ('availableDates' in variation) {
			type AvailableDate = { value: string | Moment }
			let availableDates: AvailableDate[] = variation.availableDates

			availableDates.sort((a, b) => a.value > b.value ? 1 : -1)
			availableDates = availableDates.map((date) => {
				date.value = moment(date.value)
				return date
			})

			variation.availableDates = availableDates
		}
	})

	return experience;
};

export const update = async (experienceId: number, experience: any) => {
	await BBApi.put(rootUrl + `/${experienceId}`, experience);
};

export const updateOrder = async (experienceIds: number[]) => {
	const response = await BBApi.put(rootUrl, experienceIds);
	const experiences = await response.json();
	return experiences;
};

export const remove = async (experienceId: number) => {
	await BBApi.del(rootUrl + `/${experienceId}`);
};

export const toggleExperienceRelease = async (experienceId: number, released: boolean) => {
	await BBApi.patch(rootUrl + `/${experienceId}`, { released });
};

export const getCategories = async () => {
	const response = await BBApi.get(rootUrl + `categories`);
	return await response.json() as { name: string, id: number }[];
};

export const getProvinces = async () => {
	const response = await BBApi.get(rootUrl + `provinces`);
	return await response.json() as { name: string, id: number }[];
};
